
import Vue from 'vue';

import Radio from './Radio.vue';
import RadioButton from './RadioButton.vue';
/**
- To change color on radio, modify the background and border of class <b> .eu-radio-inner </b>
- You can put custom html template on each radio with adding <b> template </b> inside props <b>options</b>
- You can add translation effect when radio is clicked and a template is showed (this logic is purely on dev side), for custom effect; modify class .eu-radio-template and .hidden (default effect is opacity)
**/
export default Vue.extend({
  name: 'EuRadioGroup',
  components: {
    EuRadio: Radio,
    EuRadioButton: RadioButton
  },
  props: {
    /**
     * Options list, fill with
     * `id`, `label`, `value`, `disabled`, `template`
     */
    options: {
      type: Array,
      required: true,
      validator: value => value.length > 0
    },
    /**
     * Name of the input
     */
    name: {
      type: String,
      required: true
    },
    /**
     * The v-model property
     */
    value: {
      type: [String, Number, Boolean],
      required: true
    },
    /**
     * Take a full row radio
     */
    block: {
      type: Boolean,
      default: false
    },
    /**
     * Type of the radio
     */
    type: {
      type: String,
      default: 'dot',
      validator: value => ['dot', 'button'].includes(value)
    },
    /**
     * Set radiobutton on error
     */
    error: {
      type: Boolean,
      default: false
    },
    /**
     * Set radiobutton on required
     */
    required: {
      type: Boolean,
      default: false
    }
  },
  created() {
    if (this.required) {
      const valueChecked = (this.options as any[]).find(option => option.value === this.value);
      this.$emit('inputState', valueChecked ? true : null);
    }
  },
  computed: {
    radioGroupClasses() {
      return {
        block: this.block
      };
    }
  },
  methods: {
    handleChange(value: string | number) {
      /**
       * Input value
       * @event input
       * @type {function}
       */
      this.$emit('input', value);
      if (this.required) {
        /**
         * This method only works if props required is given. Meaning if the value is null, inputState = false.
         * @event inputState
         * @type {function}
         */
        this.$emit('inputState', true);
      }
    }
  }
});
